import React from "react";
import Layout from "../compoents/Layout";
import projectsData from "../resources/projects";
import AOS from 'aos';
AOS.init({
  duration:1000
});


function Projects() {
  return (
    <Layout>
       
      <div className="mt-20">
        <div className="h-screen">
          <div className="h-3/4">
            <lottie-player
              src="https://assets2.lottiefiles.com/packages/lf20_ygiuluqn.json"
              background="transparent"
              speed="1"
              loop
              autoplay
            ></lottie-player>
          </div>
          <h1 className='text-4xl text-center font-bold mt-5 py-5' data-aos='slide-up' >Our Services</h1>
          <p className='text-l font-semibold text-center md:text-justify'>Some of the most important reasons for the growth of recruitment services 
           and companies willing to pay a little extra to recruitment companies to identify suitable human resources.</p>
         
        </div>
      </div>

      <div className="grid mt-20 md:grid-cols-1 grid-cols-3 items-center justify-center gap-10 mx-20 md:mx-5">
            {projectsData.map((project=>{
              return <div>
                  <div className='relative p-10 border-2 text-center rounded-tr-3xl rounded-bl-3xl border-gray-400'>
                     <h1 className='text-xl font-semibold text-yellow-500  md:text-center py-0'>{project.title}</h1>
                     <hr className="py-2"/>
                     <div className='w-full h-52 text-justify text-center md:text-l md:break-all'> {project.description}</div>
                              </div>
              </div>
            }))}
      </div>
    </Layout>
  );
}

export default Projects;
